export const ORDER_TABLE_MODULE_NAME = "bàn đặt hàng";
export const ORDER_TABLE_MODULE_URL = "/sales/order-table";
